// Julkisten sivujen ja ilmoittautumislomakkeen parannukset: toistuvat rivit, modaalit, teema.
import { setupCopySchedule } from "./lib/copy-schedule";
import { setupAll } from "./lib/enhance";
import { setupListFilters } from "./lib/list-filter";
import { setupPageSections } from "./lib/page-sections";

setupAll();
setupPageSections();
setupCopySchedule();
setupListFilters();
// live.js vaihtaa <main>-sisällön aikataulun tai sarjataulukon muuttuessa: kiinnitetään toiminnot uusiin elementteihin.
document.addEventListener("kt:main-replaced", () => {
  setupCopySchedule();
  setupListFilters();
});
